const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://mutualfunds-yv4i.onrender.com'
};

console.log('Loading config with API URL:', config.API_BASE_URL);

export default config; 